import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=79d9fff8&scoped=true"
import script from "./tip.vue?vue&type=script&lang=js"
export * from "./tip.vue?vue&type=script&lang=js"
import style0 from "./tip.vue?vue&type=style&index=0&id=79d9fff8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d9fff8",
  null
  
)

export default component.exports